import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as transformReducer from "containers/Dataset/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";

import Transform from "components/Dataset/Transform";

class TransformContainer extends React.PureComponent {
  render() {
    const { interactions } = this.props;

    return <Transform {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  addField: (forceOperation) => dispatch(transformReducer.addField(ownProps.setupId, forceOperation)),
  updateFieldOne: (index, column) => dispatch(transformReducer.updateFieldOne(ownProps.setupId, index, column)),
  updateFieldTwo: (index, column) => dispatch(transformReducer.updateFieldTwo(ownProps.setupId, index, column)),
  updateOperation: (index, operation) => dispatch(transformReducer.updateOperation(ownProps.setupId, index, operation)),
  updateSaved: (index, saved) => dispatch(transformReducer.updateSaved(ownProps.setupId, index, saved)),
  updateColumnLabel: (index, columnLabel) =>
    dispatch(transformReducer.updateColumnLabel(ownProps.setupId, index, columnLabel)),
  deleteTransform: (index) => dispatch(transformReducer.deleteTransform(ownProps.setupId, index)),
  addDataTransform: (transform) => dispatch(setupReducer.addDataTransform(ownProps.setupId, transform)),
  removeDataTransform: (transform) => dispatch(setupReducer.removeDataTransform(ownProps.setupId, transform)),
  addInteractions: () => dispatch(transformReducer.addInteractions(ownProps.setupId, ownProps.id))
});

const mapStateToProps = (state, ownProps) => ({
  dataset: homeReducer.getDataset(state, ownProps.id),
  transform: transformReducer.getCalculatedFields(state, ownProps.setupId),
  dataTransforms: setupReducer.getDataTransforms(state, ownProps.setupId),
  columnOptions: homeReducer.getColumnOptions(state, ownProps.id),
  fields: homeReducer.getFieldsArr(state, ownProps.id),
  fieldsObj: homeReducer.getFields(state, ownProps.id),
  interactions: homeReducer.getInteractions(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(TransformContainer);
